import { PromocodeData } from '@features/promocode/types/promocode-data.type';
import { createAction, props } from '@ngrx/store';
import { HttpError } from '@rd/types';
import { PromocodeValidateData } from '../../types/promocode-validate-data.type';

export const ClearPromocodeData = createAction(
  '[Promocode] Clear Promo Code Data',
);

export const ValidatePromocodeData = createAction(
  '[Promocode] Validate Promo Code Data',
  props<{ promocodeData: PromocodeValidateData }>(),
);

export const ValidatePromocodeDataSuccess = createAction(
  '[Promocode] Validate Promo Code Data Success',
  props<PromocodeData>(),
);

export const ValidatePromocodeDataFail = createAction(
  '[Promocode] Validate Promo Code Data Fail',
  props<{ error: HttpError }>(),
);

export const HydratePromocode = createAction(
  '[Promocode] Hydrate Promocode',
  props<PromocodeData>(),
);
